<template>
  <div class="mobileorderhistory">
      <div class="accordion" role="tablist">
                
            <template v-for="(nh, index) in groupedhistory">
                <div :key="index" class="historyItem">

                    <b-container>
                        <h1>{{ nh.date | formatreldate }}</h1>

                        <template v-for="nt in nh.orders">

                            <b-card 
                                :key="nt.order.id + 'trail'"
                                no-body class="mb-1">

                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <div  
                                        v-b-toggle="`orderHistory-${nt.order.id}`"
                                        class="historyTrail">
                                        
                                        <div class="trailTime">{{nt.order.created_at | formatdate('hh:mm A')}}</div>

                                        <div class="tailDetails">
                                        

                                            <div class="historyDetail">
                                                <h3>
                                                    {{nt.assign_to.name}}
                                                    <span class="dozen">{{nt.order.numberofboxes}} Dozen</span>
                                                </h3>
                                                <p>{{nt.order.shipping_address_street}} {{nt.order.shipping_address_city}} {{nt.order.shipping_address_state}} {{nt.order.shipping_address_zipcode}}</p>
                                            </div>

                                            <span class="collapseIcon">
                                                <b-icon icon="chevron-up">
                                                </b-icon>

                                                <b-icon icon="chevron-down"></b-icon>
                                            </span>
                                        </div>
                                    </div>
                                    
                                </b-card-header>

                                <b-collapse
                                    :id="`orderHistory-${nt.order.id}`"
                                    accordion="my-accordion"
                                    role="tabpanel"
                                >
                                    <b-card-body>
                                        <div class="orderTrail">
                                            <div class="orderTrailItem ">
                                                <span class="trailType done">
                                                    <b-icon icon="file-earmark-text-fill"></b-icon>
                                                </span>

                                                <div class="trailDetails">
                                                    <h4>Order created</h4>
                                                    <p>{{nt.order.created_at | forceformatdate('hh:mm A, MMM D YYYY')}}</p>
                                                </div>
                                            </div>
                                            
                                            <div class="orderTrailItem ">
                                                <span class="trailType done">
                                                    <b-icon icon="person-fill"></b-icon>
                                                </span>

                                                <div class="trailDetails">
                                                    <h4>Assigned to {{nt.assign_to.name}}</h4>
                                                    <p>{{nt.created_at | forceformatdate('h:mm A, MMM D YYYY')}}</p>
                                                </div>

                                                
                                            </div>
                                            
                                            <div class="orderTrailItem">
                                                <span :class="['trailType', {'done' : nt.order.status != 'pending' && nt.order.status != 'assign'}]">
                                                    <b-icon icon="check"></b-icon>
                                                </span>

                                                <div class="trailDetails">
                                                    <h4>Accepted</h4>

                                                    <template v-if="nt.order.status == 'pending' || nt.order.status == 'assign'">
                                                        <p>Pending</p>
                                                    </template> 

                                                    <template v-else>
                                                        <p>{{accepteddate(nt.order) | forceformatdate('h:mm A, MMM D YYYY')}}</p>
                                                    </template>

                                                    
                                                </div>
                                            </div>

                                            <template v-for="(amend, index) in amendstatuses(nt.order)">
                                                <div :key="index+'amend'" class="orderTrailItem amendstatuses">
                                                    <span 
                                                        :class="[`trailType`, 'done']">
                                                        <b-icon icon="pen-fill"></b-icon>
                                                    </span>

                                                    <div 
                                                        :class="[`trailDetails orderstatus`]">
                                                        <h4>Amended</h4>
                                                        <p class="mb-0">{{amend.created_at | forceformatdate('h:mm A, MMM D YYYY')}}</p>
                                                        <p>{{amend.notes}}</p>
                                                    </div>
                                                </div>

                                            </template>
                                            
                                            <div class="orderTrailItem">
                                                <span :class="['trailType', {'done' : nt.order.status == 'delivered' || nt.order.status == 'confirm'}]">
                                                    <b-icon icon="box-seam"></b-icon>
                                                </span>

                                                <div class="trailDetails">
                                                    <h4>Delivered</h4>

                                                    <template v-if="nt.order.status == 'delivered' || nt.order.status == 'confirm'">
                                                        <p>{{delivereddate(nt.order) | forceformatdate('h:mm A, MMM D YYYY')}}</p>
                                                    </template>

                                                    <template v-else>
                                                        <p>ETA {{nt.order.order_event_time_range ? `${nt.order.order_event_time_range}, ` : ''}} {{nt.order.delivery_date | formatdate('MMM D')}}</p>
                                                    </template>
                                                </div>

                                                <div 
                                                    v-if="nt.order.status == 'delivered' || nt.order.status == 'confirm'"
                                                    class="trailAction pl-5">
                                                    <button 
                                                        @click.prevent="checkammendstatus(nt), $bvModal.show('amendorder')"
                                                        class="btn btn-outline-primary">
                                                        Amend
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="deliveryProof">
                                            <img
                                                :src="getdeliverimg(nt.order)"
                                                alt=""
                                            />
                                        </div>

                                        <div class="orderContactDetails">
                                            <div class="contactItem">
                                                <b-icon icon="telephone-fill"></b-icon>
                                                {{nt.order.phone_number | VMask('(###) ###-####')}}
                                            </div>

                                            <div class="contactItem">
                                                <b-icon icon="calendar"></b-icon> {{nt.order.order_event_time_range ? `${nt.order.order_event_time_range}, ` : ''}} {{nt.order.delivery_date | formatdate('MMM D')}}
                                            </div>

                                            <div class="contactItem">
                                                <b-icon icon="geo-alt"></b-icon> {{nt.order.shipping_address_street}} {{nt.order.shipping_address_city}} {{nt.order.shipping_address_state}} {{nt.order.shipping_address_zipcode}}
                                            </div>

                                            <div class="contactItem">
                                                <div class="orderNote">
                                                    {{nt.order.order_notes ? nt.order.order_notes : 'No notes'}}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="orderSummary">
                                            <div class="orderSummaryHeader">
                                                <b-row>
                                                    <b-col cols="9">
                                                        <h4>Order {{nt.order.order_number}} summary</h4>
                                                    </b-col>

                                                    <b-col cols="3 dozen">
                                                        {{nt.order.numberofboxes}} Dozen
                                                    </b-col>
                                                </b-row>
                                            </div>

                                            <div class="orderBreakdown">
                                                <template v-for="(box, index) in grouporderbox(nt.order.orderboxitems)">

                                                    <div :key="index" class="orderBreakdownItem">
                                                        <div 
                                                            class="flavorlist">

                                                            <template v-for="(flavor, index) in groupflavors(box.flavors)">
                                                                <div :key="index" class="flavorname">
                                                                    {{flavor.name}}
                                                                </div>
                                                            </template>

                                                        </div>
                                                    </div>
                                                </template>

                                            </div>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                            
                        </template>
                    </b-container>
                </div>
            </template>
        </div>
  </div>
</template>

<script>
/**
 * Declerations
 */
// mixins
import {driverorderhistorymixins} from "@/mixins/driverorderhistorymixins"

export default {
    mixins : [driverorderhistorymixins],
    
}
</script>

<style>

</style>